import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import * as React from 'react';
import { useTheme } from '@emotion/react';
import clsx from 'clsx';
import { misc, text } from '../assets/styles/utility';
import Close from './Close';
import { jsx as ___EmotionJSX } from "@emotion/react";
export const StylesAlertBase = theme => [misc.fluidSize({
  theme,
  property: 'padding',
  from: theme.space.base,
  to: theme.space.large
}), {
  borderLeft: '8px solid transparent',
  color: theme.fontColor.base,
  borderRadius: theme.borderRadius.base,
  'a:not([class]), a[class=""], .u-link': [text.underline, {
    color: 'currentColor',
    '&:hover, &:focus': {
      color: 'currentColor'
    }
  }]
}];
export const StylesAlertDefault = theme => ({
  borderColor: theme.color.border.base,
  background: theme.color.panel.base
});
export const StylesAlertPrimary = theme => ({
  borderColor: theme.color.primary.base,
  background: theme.color.primary.light
});
export const StylesAlertWarning = theme => ({
  borderColor: theme.color.warning.base,
  background: theme.color.warning.light
});
export const StylesAlertDanger = theme => ({
  borderColor: theme.color.danger.base,
  background: theme.color.danger.light,
  '.CK__Alert__Title, .CK__Alert__Close': {
    color: theme.color.danger.base
  }
});

const Alert = _ref => {
  let {
    children,
    className,
    reveal,
    setReveal,
    title,
    type = 'default'
  } = _ref,
      rest = _objectWithoutProperties(_ref, ["children", "className", "reveal", "setReveal", "title", "type"]);

  const theme = useTheme();
  const ref = React.useRef();
  if (!reveal && typeof setReveal === 'function') return null;
  return ___EmotionJSX("div", _extends({
    css: [StylesAlertBase(theme), typeof setReveal === 'function' && {
      display: 'grid',
      gridTemplateColumns: '1fr auto',
      gap: theme.space.small
    }, type === 'default' && StylesAlertDefault(theme), type === 'primary' && StylesAlertPrimary(theme), type === 'warning' && StylesAlertWarning(theme), type === 'danger' && StylesAlertDanger(theme), process.env.NODE_ENV === "production" ? "" : ";label:Alert;"],
    className: clsx('CK__Alert', className),
    role: "alert",
    ref: ref
  }, rest), ___EmotionJSX("div", {
    className: "CK__Alert__Content " + theme.settings.classes.trim
  }, title && ___EmotionJSX("h4", {
    className: "CK__Alert__Title"
  }, title), children), typeof setReveal === 'function' && ___EmotionJSX(Close, {
    className: "CK__Alert__Close",
    onClick: () => setReveal(false)
  }));
};

export default Alert;